/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Loud_Heron_PlanInputs */

const en_full_loud_heron_plan = /** @type {(inputs: Full_Loud_Heron_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://help.kultify.com/en/`)
};

const de_full_loud_heron_plan = /** @type {(inputs: Full_Loud_Heron_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://help.kultify.com/de/`)
};

/**
* | output |
* | --- |
* | "https://help.kultify.com/en/" |
*
* @param {Full_Loud_Heron_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_loud_heron_plan = /** @type {((inputs?: Full_Loud_Heron_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Loud_Heron_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_loud_heron_plan(inputs)
	return de_full_loud_heron_plan(inputs)
});